import "phaser";

import { BootScene } from "./scenes/BootScene";
import { Game } from "phaser";
import { GameConstants } from "./GameConstants";
import { PreloadScene } from "./scenes/PreloadScene";
import { CanvasScene } from "./scenes/Board/CanvasScene";
import { GuiScene } from "./scenes/GUI/GuiScene";
import { LevelSelectionScene } from "./scenes/LevelSelection/LevelSelectionScene";
import { HomeScene } from "./scenes/Home/HomeScene";

/// <reference path="Game.ts"/>
let game: Game;

window.onload = () => {

    let renderer: number;
    let ua = navigator.userAgent;

    if (ua.match(/iPhone/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || /Kindle/i.test(ua) || /Silk/i.test(ua) || /KFTT/i.test(ua) || /KFOT/i.test(ua) || /KFJWA/i.test(ua) || /KFJWI/i.test(ua) || /KFSOWI/i.test(ua) || /KFTHWA/i.test(ua) || /KFTHWI/i.test(ua) || /KFAPWA/i.test(ua) || /KFAPWI/i.test(ua)) {
        renderer = Phaser.CANVAS;
    } else {
        renderer = Phaser.AUTO;
    }

    const gameConfig = {
        type: renderer,
        backgroundColor: "#ffffff",
        width: GameConstants.GAME_WIDTH,
        height: GameConstants.GAME_HEIGHT,
        antialias: true, 
        scale: {
            mode: Phaser.Scale.FIT,
            parent: "",
            width: GameConstants.GAME_WIDTH,
            height: GameConstants.GAME_HEIGHT,
            autoCenter: Phaser.Scale.CENTER_HORIZONTALLY
        },

        scene: [
            BootScene, 
            PreloadScene, 
            CanvasScene,
            GuiScene,
            LevelSelectionScene, 
            HomeScene      
        ]      
    };

    game = new Game(gameConfig);

    window.focus();
    resize();
    window.addEventListener("resize", resize, false);
};

function resize(): void {

    const canvas = document.querySelector("canvas");
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowRatio = windowWidth / windowHeight;

    const gameWidth: any = game.config.width;
    const gameHeight: any = game.config.height;

    const gameRatio = gameWidth / gameHeight;
    
    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    } else {
        canvas.style.width = (windowHeight * gameRatio) + "px";
        canvas.style.height = windowHeight + "px";
    }
}
